import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { getCurrentLocation } from '../lib/utils/map';
import { useSpots } from '../lib/spots';
import { useStamps } from '../lib/stamps';

type Props = {
    id: number,
};

export const CheckIn: FC<Props> = ({ id }) => {
    const [success, setSuccess] = useState(false);
    const [code, setCode] = useState(0);
    const [url, setUrl] = useState("");
    const [buttonLabel, setButtonLabel] = useState<String | null>(null);
    const [spot, setSpot] = useState<Spot | null>(null);
    const [animated, setAnimated] = useState(false);
    const [state, setState] = useState('loading');
    const { get } = useSpots();
    const { checkin } = useStamps();
    const history = useHistory();
    const handleClose = () => {
        if (state === 'loading') {
            return;
        }

        if (state === 'open') {
            setState('done');
        }
    };

    const stampIcons = {
        '飲食店': '/img/map_stamp_icons/stamp-rest.png',
        'ヘアサロン': '/img/map_stamp_icons/stamp-cut.png',
        'スナックキャンディ': '/img/map_stamp_icons/stamp-candy.png',
        '宿泊': '/img/map_stamp_icons/stamp-hotel.png',
        'その他': '/img/map_stamp_icons/stamp-other.png',
        '自販機': '/img/map_stamp_icons/stamp-vend.png',
        '居酒屋・バー': '/img/map_stamp_icons/stamp-bar.png',
        'レストラン・カフェ': '/img/map_stamp_icons/stamp-cafe.png',
        'スイーツ': '/img/map_stamp_icons/stamp-sweets.png',
        '健康': '/img/map_stamp_icons/stamp-health.png',
        '医療・福祉': '/img/map_stamp_icons/stamp-medical.png',
        '小売': '/img/map_stamp_icons/stamp-retail.png',
        'エンタメ・レジャー': '/img/map_stamp_icons/stamp-entertainment.png',
        '習いごと': '/img/map_stamp_icons/stamp-education.png',
        'ビューティ': '/img/map_stamp_icons/stamp-beauty.png',
        'レンタルスペース': '/img/map_stamp_icons/stamp-rentalspace.png',
        'ビジネス': '/img/map_stamp_icons/stamp-buisiness.png',
        '保育園・幼稚園': '/img/map_stamp_icons/stamp-nursery.png',
        '農業': '/img/map_stamp_icons/stamp-agri.png',
    };

    function openLocationMapTab() {
        // @ts-ignore
        document.querySelector('.tab:nth-child(1)')?.click();
        // @ts-ignore
        document.querySelector('.tab:nth-child(2)')?.click();
        window.scrollTo(0, -1000);
    }

    useEffect(() => {
        let tid: any;
        async function initialize() {

            window.location.href = '/stores/5020/stamps?checkin=1';

            const loc = await getCurrentLocation(() => { });
            if (loc === null) {
                setSuccess(false);
                setCode(4);
                setUrl('/map/help/geolocation');
                setButtonLabel("詳しくはこちら");
                setState('open');
                return;
            }

            const { result, errorCode, url } = await checkin(id);
            setSuccess(result);
            if (errorCode === 6) {
                window.location.href = '/mypages#payments';
                return;
            };
            setCode(errorCode);
            setUrl(url);
            if (result) {
                document.querySelector(".floating-action-button")?.remove();
            };

            const spot = await get(id);
            setSpot(spot);

            setState('open');

            tid = setTimeout(() => {
                setAnimated(true);
                openLocationMapTab();
            }, 1000);
            return () => {
                clearTimeout(tid);
            }
        };
        initialize();
    }, []);

    const code2msg = (code: number) => {
        switch (code) {
            case 1:
                return <>サービスをご利用になるには、<br />『西野亮廣エンタメ研究所』<br />への入会が必要です。</>;
            case 2:
                return <>対象のお店が<br />近くに見つかりませんでした。<br />店内で再度お試しください。</>;
            case 3:
                return <>こちらのお店の本日のスタンプは獲得済みです。</>;
            case 4:
                return <>位置情報を取得<br />できませんでした<br />サービスをご利用になるには<br />位置情報を許可してください。<br /></>;
            case 5:
                return <>自分のお店のスタンプは<br />取得できません。</>
            default:
                return null;
        }
    }

    return (
        <>
            {state !== 'done' && (
                <div className="dialog-bg" onClick={handleClose}>
                    <div className={['dialog-wrap', state === 'open' ? '-open' : ''].join(' ')}>
                        <div className={['dialog', success ? '-ok' : '-ng'].join(' ')}>
                            <div className="btn-close" onClick={handleClose}>×</div>
                            {success && spot ? (
                                <>
                                    <div className="icon -ok stamp">
                                        <div className={['bg', !animated ? '-animate' : ''].join(' ')}>
                                            <img src="/img/map_stamp_icons/stars.png" alt="" />
                                        </div>
                                        <div className={['fg', !animated ? '-animate' : ''].join(' ')}>
                                            {/* @ts-ignore */}
                                            <img src={stampIcons[spot.genre]} alt="" />
                                        </div>
                                    </div>
                                    <div className="spot-name">{spot.name}</div>
                                    <div className="message">スタンプGET!</div>
                                </>
                            ) : (
                                <>
                                    {code === 1 ? (
                                        <div className="icon -nishino">
                                            <img className="mark" src="/img/icon_hat.png" />
                                        </div>
                                    ) : (
                                        <div className="icon">
                                            <img className="mark" src="/img/map_stamp_icons/ng.png" />
                                        </div>
                                    )}
                                    <div className="message">
                                        {code2msg(code)}
                                    </div>
                                    {url && <a className="btn-salon" href={url}>{buttonLabel ?? "入会はこちら"}</a>}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .dialog-bg {
                    display: flex;
                    position: fixed;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.5);
                    z-index: 100;
                    align-items: center;
                    justify-content: center;
                }
                .dialog-wrap {
                    display: none;
                    position: relative;
                    max-width: 300px;
                    background: #fff;
                    border-radius: 2rem;
                }
                .dialog-wrap.-open {
                    display: flex;
                }
                .dialog {
                    padding: 2rem;
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                }
                .dialog > .btn-close {
                    position: absolute;
                    top: 1rem;
                    right: 1rem;
                    font-size: 2rem;
                    font-weight: bold;
                    line-height: 1;
                    color: #fd862c;
                    cursor: pointer;
                }
                .dialog > .message {
                    font-size: 1.5rem;
                    font-weight: bold;
                }
                .dialog.-ok > .icon {
                    margin: 1.5rem 0;
                }
                .dialog.-ok > .spot-name {
                    font-size: 1rem;
                    font-weight: bold;
                }
                .dialog.-ng > .icon {
                    padding: 1rem 0;
                }
                .dialog.-ng > .message {
                    font-size: 1rem;
                    font-weight: normal;
                    text-align: center;
                }
                .dialog.-ng > .btn-salon {
                    margin-top: 1rem;
                    padding: 1rem;
                    width: 100%;
                    border-radius: 100vh;
                    background: #fd862c;
                    color: #ffffff;
                    font-size: 0.8rem;
                    text-align: center;
                    text-decoration: none;
                    cursor: pointer;
                }
                .icon > .mark {
                    width: 80px;
                }
                .icon.-nishino > .mark {
                    width: 60px;
                }
                .stamp {
                    position: relative;
                }
                .stamp > .bg,
                .stamp > .fg {
                    width: 100%;
                }
                .stamp > .bg {
                    opacity: 0;
                    animation-name: bg-anime;
                    animation-duration: 1s;
                    animation-fill-mode: forwards;
                    animation-delay: 2s;
                }
                @keyframes bg-anime {
                    0% {
                        opacity: 0;
                    }
                    100% {
                        opacity: 1;
                    }
                }
                .stamp > .fg {
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    opacity: 1;
                    transition: 0.7s ease-in;
                    transform-origin: center center;
                }
                .stamp > .fg > img {
                    width: 120px;
                }
                .stamp > .fg.-animate {
                    opacity: 0;
                    transform: scale(3) rotate(-20deg);
                }
            `}</style>
        </>
    );
};
